import { withValidate } from "./withValidate";
import { useState, useEffect } from "react";
export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
  imgSrc?: string;
}
export interface SelectProps {
  max?: number;
  options: SelectOption[];
  col?: number;
  defaultValues?: string | string[];
  onChange?: (value: string | string[]) => unknown;
  className?: string;
}
export const SelectBoxImg = ({
  defaultValues,
  onChange,
  options,
  max,
  value,
}: SelectProps & { value?: string | string[] }) => {
  const [values, setValues] = useState<string[]>(
    Array.isArray(defaultValues)
      ? defaultValues
      : defaultValues
        ? [defaultValues]
        : []
  );

  // value prop이 변경되면 내부 상태 업데이트
  useEffect(() => {
    if (value !== undefined) {
      const newValues = Array.isArray(value) ? value : value ? [value] : [];
      setValues(newValues);
    }
  }, [value]);

  const handleChange = (value: string) => {
    let newValues: string[];

    if (values.includes(value)) {
      // 이미 선택된 값이면 제거
      newValues = values.filter((v) => v !== value);
    } else {
      // 선택되지 않은 값이면 추가 (max 제한 확인)
      if (max && values.length >= max) {
        // max 제한에 도달했으면 가장 오래된 값 제거
        newValues = [...values.slice(1), value];
      } else {
        newValues = [...values, value];
      }
    }

    setValues(newValues);
    onChange?.(newValues);
  };

  return (
    <div>
      <div className="flex overflow-x-auto gap-4 pb-2">
        {options.map((option) => {
          const isActive = values.includes(option.value);
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => handleChange(option.value)}
              className="flex flex-col items-center focus:outline-none"
            >
              <div
                className={`w-24 h-24 rounded-lg overflow-hidden flex items-center justify-center border-2 transition
                  ${isActive ? "border-orange-400" : "border-[#FFFFFF] bg-white"}
                `}
              >
                <img
                  src={option.imgSrc}
                  alt={option.label}
                  className="object-cover w-full h-full"
                />
              </div>
              <span
                className={`mt-2 text-sm font-medium transition
                  ${isActive ? "text-orange-500" : "text-[#9999]"}
                `}
              >
                {option.label}
              </span>
            </button>
          );
        })}
        {/* <button
          type="button"
          onClick={() => {}} // 원하는 함수로 교체
          className="flex flex-col items-center focus:outline-none"
        >
          <div className="w-24 h-24 rounded-lg bg-[#E9E9E9] flex items-center justify-center">
            <span className="text-3xl text-[#C4C4C4]">+</span>
          </div>
          <span className="mt-2 text-sm text-[#9999]">추가</span>
        </button> */}
      </div>
    </div>
  );
};
export const ValidateSelectBoxImg = withValidate(SelectBoxImg);

// export const Select = Object.assign(SelectRoot, {
//   Validate: ValidateSelect,
//   Check,
//   CheckWrap,
//   ValidateCheckWrap,
// });
